module.exports = __webpack_public_path__ + "assets/652f760d4271e1263ab9476a0bbc3b13.mp3";